"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.RegistrationTypes = exports.LossReasonType = exports.PlanType = exports.InvestmentType = exports.PaymentMethod = exports.IdvFlowType = exports.SosUserAuthResponseCode = exports.DecisionType = exports.CompletionStatus = exports.IdvKeyType = exports.IdvStatus = exports.ResultType = exports.ContentTypes = exports.HateoasLinkAction = exports.AccountType2 = exports.Iso4217Code = exports.TransactionStatus = exports.DebitCreditMemo = exports.InvestmentTransactionType = exports.AssetClass = exports.DebtType = exports.OptionType = exports.MutualFundType = exports.PositionType = exports.HoldingType = exports.OperationId = exports.AvailabilityStatus = exports.EDeliveryType = exports.SolApiResponseCode = exports.MfaStatus = exports.AccountType = exports.RecoveryVerificationType = exports.AuditLogType = exports.AlertType = exports.AgreementType = exports.SPCoreClient = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const axios_1 = __importDefault(require("axios"));
class SPCoreClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://localhost:44311";
    }
    accountsInformation_GetAccounts(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts-information";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountsInformation_GetAccounts(_response);
        });
    }
    processAccountsInformation_GetAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    accountsInformation_GetAccountsCompaniesDetails(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts-information/companies-details";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountsInformation_GetAccountsCompaniesDetails(_response);
        });
    }
    processAccountsInformation_GetAccountsCompaniesDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    accountsInformation_GetAccountsCompanies(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts-information/companies";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountsInformation_GetAccountsCompanies(_response);
        });
    }
    processAccountsInformation_GetAccountsCompanies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    accountsInformation_GetTaxIdNameLine(accountNumber, issueNumber, companyId, userRegionCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts-information/taxid-name-line?";
        if (accountNumber === null)
            throw new Error("The parameter 'accountNumber' cannot be null.");
        else if (accountNumber !== undefined)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (userRegionCode !== undefined && userRegionCode !== null)
            url_ += "userRegionCode=" + encodeURIComponent("" + userRegionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountsInformation_GetTaxIdNameLine(_response);
        });
    }
    processAccountsInformation_GetTaxIdNameLine(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    accountsInformation_GetAccountsSummary(issueNumber, userRegionCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts-information/summary?";
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        if (userRegionCode !== undefined && userRegionCode !== null)
            url_ += "userRegionCode=" + encodeURIComponent("" + userRegionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountsInformation_GetAccountsSummary(_response);
        });
    }
    processAccountsInformation_GetAccountsSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    accountsInformation_GetAccountAddress(accountNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts-information/account-address/{accountNumber}/address";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountsInformation_GetAccountAddress(_response);
        });
    }
    processAccountsInformation_GetAccountAddress(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    agreement_GetHtml(type, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/agreements/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAgreement_GetHtml(_response);
        });
    }
    processAgreement_GetHtml(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    agreement_ActionAccept(type, request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/agreements/{type}/accept";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAgreement_ActionAccept(_response);
        });
    }
    processAgreement_ActionAccept(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    agreement_GetStatus(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/agreements";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAgreement_GetStatus(_response);
        });
    }
    processAgreement_GetStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    alerts_GetAlerts(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/alerts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAlerts_GetAlerts(_response);
        });
    }
    processAlerts_GetAlerts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    audit_PostAuditLog(auditRequest, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/authentication/audit";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(auditRequest);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAudit_PostAuditLog(_response);
        });
    }
    processAudit_PostAuditLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    authentication_ActionGetUserId(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/authentication/userid";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAuthentication_ActionGetUserId(_response);
        });
    }
    processAuthentication_ActionGetUserId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    authentication_ActionGetUserIdBySosUserId(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/authentication/get-userid-by-sos-id";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAuthentication_ActionGetUserIdBySosUserId(_response);
        });
    }
    processAuthentication_ActionGetUserIdBySosUserId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    authentication_ActionCheckUserEligibilityForLogin(userId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/authentication/eligibility/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAuthentication_ActionCheckUserEligibilityForLogin(_response);
        });
    }
    processAuthentication_ActionCheckUserEligibilityForLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    authentication_GetUserState(userId, policy, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/authentication/state/{userId}/{policy}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (policy === undefined || policy === null)
            throw new Error("The parameter 'policy' must be defined.");
        url_ = url_.replace("{policy}", encodeURIComponent("" + policy));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAuthentication_GetUserState(_response);
        });
    }
    processAuthentication_GetUserState(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    bankAccounts_List(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/bankaccounts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processBankAccounts_List(_response);
        });
    }
    processBankAccounts_List(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    cache_InvalidateCache(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/cache/invalidate";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCache_InvalidateCache(_response);
        });
    }
    processCache_InvalidateCache(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    cache_InvalidateIssueCache(isClearAll, issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/cache/invalidate-issue?";
        if (isClearAll === null)
            throw new Error("The parameter 'isClearAll' cannot be null.");
        else if (isClearAll !== undefined)
            url_ += "isClearAll=" + encodeURIComponent("" + isClearAll) + "&";
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCache_InvalidateIssueCache(_response);
        });
    }
    processCache_InvalidateIssueCache(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    company_GetCompanies(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/companies";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCompany_GetCompanies(_response);
        });
    }
    processCompany_GetCompanies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    company_GetCompaniesForEmployeeNumber(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/companies/foremployeenumber";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCompany_GetCompaniesForEmployeeNumber(_response);
        });
    }
    processCompany_GetCompaniesForEmployeeNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    company_LogoExists(model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/companies/logoExists";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCompany_LogoExists(_response);
        });
    }
    processCompany_LogoExists(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    country_GetCompanies(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/countries";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCountry_GetCompanies(_response);
        });
    }
    processCountry_GetCompanies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    country_GetWireTransferCountryConfig(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/countries/wire-transfer/country-config";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCountry_GetWireTransferCountryConfig(_response);
        });
    }
    processCountry_GetWireTransferCountryConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    country_GetInternationalACH(userRegionCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/countries/international-ach/{userRegionCode}";
        if (userRegionCode === undefined || userRegionCode === null)
            throw new Error("The parameter 'userRegionCode' must be defined.");
        url_ = url_.replace("{userRegionCode}", encodeURIComponent("" + userRegionCode));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCountry_GetInternationalACH(_response);
        });
    }
    processCountry_GetInternationalACH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    cswUser_GetContactInfo(userId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/graph/{userId}/contactInfo";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCswUser_GetContactInfo(_response);
        });
    }
    processCswUser_GetContactInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    cswUser_GetAzureMfaStatus(userId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/graph/{userId}/mfaStatus";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCswUser_GetAzureMfaStatus(_response);
        });
    }
    processCswUser_GetAzureMfaStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    dividends_GetDripDetails(issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/dividends/{issueNumber}";
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDividends_GetDripDetails(_response);
        });
    }
    processDividends_GetDripDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    dividends_GetDripDetailsByAccountNumber(issueNumber, accountNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/dividends/{issueNumber}/{accountNumber}";
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDividends_GetDripDetailsByAccountNumber(_response);
        });
    }
    processDividends_GetDripDetailsByAccountNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    dividends_GetDividends(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/dividends";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDividends_GetDividends(_response);
        });
    }
    processDividends_GetDividends(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    dividends_UpdateDripDetails(issueNumber, accountNumber, requestData, cancelToken) {
        let url_ = this.baseUrl + "/accountNumber/{accountNumber}?";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(requestData);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDividends_UpdateDripDetails(_response);
        });
    }
    processDividends_UpdateDripDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    documents_GetDocuments(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/documents";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDocuments_GetDocuments(_response);
        });
    }
    processDocuments_GetDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    documents_GetFilteredDocuments(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/documents";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDocuments_GetFilteredDocuments(_response);
        });
    }
    processDocuments_GetFilteredDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    documents_Download(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/documents/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDocuments_Download(_response);
        });
    }
    processDocuments_Download(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    documents_DownloadCurrentAccountBalance(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/documents/account-balance/current";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDocuments_DownloadCurrentAccountBalance(_response);
        });
    }
    processDocuments_DownloadCurrentAccountBalance(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    edelivery_Get(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/edelivery";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEdelivery_Get(_response);
        });
    }
    processEdelivery_Get(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    edelivery_Update(model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/edelivery";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEdelivery_Update(_response);
        });
    }
    processEdelivery_Update(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    edelivery_GetGlobal(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/edelivery/global";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEdelivery_GetGlobal(_response);
        });
    }
    processEdelivery_GetGlobal(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    edelivery_UpdateGlobal(model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/edelivery/global";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEdelivery_UpdateGlobal(_response);
        });
    }
    processEdelivery_UpdateGlobal(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    edelivery_GetProxy(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/edelivery/proxy";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEdelivery_GetProxy(_response);
        });
    }
    processEdelivery_GetProxy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    edelivery_UpdateProxy(model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/edelivery/proxy";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEdelivery_UpdateProxy(_response);
        });
    }
    processEdelivery_UpdateProxy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    emailMismatch_ActionSyncEmails(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/email-mismatch/sync";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEmailMismatch_ActionSyncEmails(_response);
        });
    }
    processEmailMismatch_ActionSyncEmails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    emails_ActionSendEmailWithOtp(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/email/sendWithOtp";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEmails_ActionSendEmailWithOtp(_response);
        });
    }
    processEmails_ActionSendEmailWithOtp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    fdxV5_GetAvailability(operationId, cancelToken) {
        let url_ = this.baseUrl + "/api/fdx/v5/availability?";
        if (operationId !== undefined && operationId !== null)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFdxV5_GetAvailability(_response);
        });
    }
    processFdxV5_GetAvailability(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    fdxV5_GetAccounts(accountIds, startTime, endTime, resultType, offset, limit, cancelToken) {
        let url_ = this.baseUrl + "/api/fdx/v5/accounts?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "accountIds=" + encodeURIComponent("" + item) + "&"; });
        if (startTime !== undefined && startTime !== null)
            startTime && startTime.forEach(item_ => { url_ += "startTime=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        if (endTime !== undefined && endTime !== null)
            endTime && endTime.forEach(item_ => { url_ += "endTime=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        if (resultType !== undefined && resultType !== null)
            url_ += "resultType=" + encodeURIComponent("" + resultType) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFdxV5_GetAccounts(_response);
        });
    }
    processFdxV5_GetAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    fdxV5_GetAccount(accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/fdx/v5/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFdxV5_GetAccount(_response);
        });
    }
    processFdxV5_GetAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    features_GetFeatures(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/features";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFeatures_GetFeatures(_response);
        });
    }
    processFeatures_GetFeatures(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    features_GetIsEnabled(featureName, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/features/{featureName}";
        if (featureName === undefined || featureName === null)
            throw new Error("The parameter 'featureName' must be defined.");
        url_ = url_.replace("{featureName}", encodeURIComponent("" + featureName));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFeatures_GetIsEnabled(_response);
        });
    }
    processFeatures_GetIsEnabled(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    fraud_CheckForFraud(fraudData, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/fraud/validate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(fraudData);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFraud_CheckForFraud(_response);
        });
    }
    processFraud_CheckForFraud(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    hangfire_SetCookie(key, cancelToken) {
        let url_ = this.baseUrl + "/hangfire/login?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processHangfire_SetCookie(_response);
        });
    }
    processHangfire_SetCookie(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return Promise.resolve(resultdefault);
        }
    }
    health_IsHealthyGET(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/health";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processHealth_IsHealthyGET(_response);
        });
    }
    processHealth_IsHealthyGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 503) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    health_IsHealthyHEAD(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/health";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processHealth_IsHealthyHEAD(_response);
        });
    }
    processHealth_IsHealthyHEAD(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 503) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    idv_GetEffectiveStatus(keyType, keyValue, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/users/{keyType}/{keyValue}";
        if (keyType === undefined || keyType === null)
            throw new Error("The parameter 'keyType' must be defined.");
        url_ = url_.replace("{keyType}", encodeURIComponent("" + keyType));
        if (keyValue === undefined || keyValue === null)
            throw new Error("The parameter 'keyValue' must be defined.");
        url_ = url_.replace("{keyValue}", encodeURIComponent("" + keyValue));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_GetEffectiveStatus(_response);
        });
    }
    processIdv_GetEffectiveStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    idv_GetEffectiveStatusOnly(keyType, keyValue, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/users/{keyType}/{keyValue}/status";
        if (keyType === undefined || keyType === null)
            throw new Error("The parameter 'keyType' must be defined.");
        url_ = url_.replace("{keyType}", encodeURIComponent("" + keyType));
        if (keyValue === undefined || keyValue === null)
            throw new Error("The parameter 'keyValue' must be defined.");
        url_ = url_.replace("{keyValue}", encodeURIComponent("" + keyValue));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_GetEffectiveStatusOnly(_response);
        });
    }
    processIdv_GetEffectiveStatusOnly(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    idv_SetStatus(keyType, keyValue, status, changedBy, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/users/{keyType}/{keyValue}/status?";
        if (keyType === undefined || keyType === null)
            throw new Error("The parameter 'keyType' must be defined.");
        url_ = url_.replace("{keyType}", encodeURIComponent("" + keyType));
        if (keyValue === undefined || keyValue === null)
            throw new Error("The parameter 'keyValue' must be defined.");
        url_ = url_.replace("{keyValue}", encodeURIComponent("" + keyValue));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (changedBy !== undefined && changedBy !== null)
            url_ += "changedBy=" + encodeURIComponent("" + changedBy) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_SetStatus(_response);
        });
    }
    processIdv_SetStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    idv_GetCurrentUserEffectiveStatus(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/users/current/status";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_GetCurrentUserEffectiveStatus(_response);
        });
    }
    processIdv_GetCurrentUserEffectiveStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    idv_SetStatusBulk(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/users/statuses";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_SetStatusBulk(_response);
        });
    }
    processIdv_SetStatusBulk(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 207) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    idv_GetLandingPage(identificationId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/journey/{identificationId}/complete";
        if (identificationId === undefined || identificationId === null)
            throw new Error("The parameter 'identificationId' must be defined.");
        url_ = url_.replace("{identificationId}", encodeURIComponent("" + identificationId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_GetLandingPage(_response);
        });
    }
    processIdv_GetLandingPage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    idv_StartJourney(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/journey/start";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_StartJourney(_response);
        });
    }
    processIdv_StartJourney(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    idv_GetFlowEnabled(flow, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/idv/configuration/flows/{flow}/enabled";
        if (flow === undefined || flow === null)
            throw new Error("The parameter 'flow' must be defined.");
        url_ = url_.replace("{flow}", encodeURIComponent("" + flow));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIdv_GetFlowEnabled(_response);
        });
    }
    processIdv_GetFlowEnabled(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    internal_ActionMigrateUsers(users, cancelToken) {
        let url_ = this.baseUrl + "/api/internal/users";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(users);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInternal_ActionMigrateUsers(_response);
        });
    }
    processInternal_ActionMigrateUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    investments_Create(userId, request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/investments?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInvestments_Create(_response);
        });
    }
    processInvestments_Create(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    investments_Edit(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/investments";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInvestments_Edit(_response);
        });
    }
    processInvestments_Edit(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    investments_StopInvestment(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/investments";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInvestments_StopInvestment(_response);
        });
    }
    processInvestments_StopInvestment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    investments_List(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/investments";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInvestments_List(_response);
        });
    }
    processInvestments_List(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    investments_CheckForBatchedInvestment(accountNumber, issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/investments/{accountNumber}/{issueNumber}/is-batch-pending";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInvestments_CheckForBatchedInvestment(_response);
        });
    }
    processInvestments_CheckForBatchedInvestment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    investments_Get(accountNumber, issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/investments/{accountNumber}/{issueNumber}";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInvestments_Get(_response);
        });
    }
    processInvestments_Get(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    investments_GetPreferences(issueNumber, isDpp, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/investments/issues/{issueNumber}/preferences?";
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        if (isDpp === null)
            throw new Error("The parameter 'isDpp' cannot be null.");
        else if (isDpp !== undefined)
            url_ += "isDpp=" + encodeURIComponent("" + isDpp) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processInvestments_GetPreferences(_response);
        });
    }
    processInvestments_GetPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    issues_GetPlansAll(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/issues/plans";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIssues_GetPlansAll(_response);
        });
    }
    processIssues_GetPlansAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    issues_GetUserPlans(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/issues/userplans";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIssues_GetUserPlans(_response);
        });
    }
    processIssues_GetUserPlans(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    issues_GetPlans(issueNumber, planType, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/issues/{issueNumber}/plans?";
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIssues_GetPlans(_response);
        });
    }
    processIssues_GetPlans(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    issues_GetPlanWithFees(issueNumber, userRegionCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/issues/{issueNumber}/{userRegionCode}/plan-with-fees";
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        if (userRegionCode === undefined || userRegionCode === null)
            throw new Error("The parameter 'userRegionCode' must be defined.");
        url_ = url_.replace("{userRegionCode}", encodeURIComponent("" + userRegionCode));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processIssues_GetPlanWithFees(_response);
        });
    }
    processIssues_GetPlanWithFees(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    lostCertificate_GetAccountLostCertificatesEligibility(accountNumber, issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/certificates/lost?";
        if (accountNumber === null)
            throw new Error("The parameter 'accountNumber' cannot be null.");
        else if (accountNumber !== undefined)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLostCertificate_GetAccountLostCertificatesEligibility(_response);
        });
    }
    processLostCertificate_GetAccountLostCertificatesEligibility(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    lostCertificate_CreateLostCertificateRequest(accountNumber, issueNumber, certificateRequests, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/certificates/lost?";
        if (accountNumber === null)
            throw new Error("The parameter 'accountNumber' cannot be null.");
        else if (accountNumber !== undefined)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(certificateRequests);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLostCertificate_CreateLostCertificateRequest(_response);
        });
    }
    processLostCertificate_CreateLostCertificateRequest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_GetMessages(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_GetMessages(_response);
        });
    }
    processMessage_GetMessages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_DeleteMessages(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_DeleteMessages(_response);
        });
    }
    processMessage_DeleteMessages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_ActionCreateNewMessage(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_ActionCreateNewMessage(_response);
        });
    }
    processMessage_ActionCreateNewMessage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_GetUnreadMessageCount(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages/unreadCount";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_GetUnreadMessageCount(_response);
        });
    }
    processMessage_GetUnreadMessageCount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_GetCompanyMessages(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages/company";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_GetCompanyMessages(_response);
        });
    }
    processMessage_GetCompanyMessages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_UpdateReadStatus(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages/updateReadStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_UpdateReadStatus(_response);
        });
    }
    processMessage_UpdateReadStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_ActionReplyToMessage(messageId, messageBody, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages/{messageId}/reply";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(messageBody);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_ActionReplyToMessage(_response);
        });
    }
    processMessage_ActionReplyToMessage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_GetAttachments(messageId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages/{messageId}/attachments";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_GetAttachments(_response);
        });
    }
    processMessage_GetAttachments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_GetAttachmentData(messageId, attachmentId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages/{messageId}/attachment/{attachmentId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_GetAttachmentData(_response);
        });
    }
    processMessage_GetAttachmentData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    message_GetContactQuestions(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/messages/contact-questions";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMessage_GetContactQuestions(_response);
        });
    }
    processMessage_GetContactQuestions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    portfolio_GetPortfolio(applyZeroFilter, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/portfolio?";
        if (applyZeroFilter !== undefined && applyZeroFilter !== null)
            url_ += "applyZeroFilter=" + encodeURIComponent("" + applyZeroFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPortfolio_GetPortfolio(_response);
        });
    }
    processPortfolio_GetPortfolio(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    portfolio_GetDividends(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/portfolio/dividends";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPortfolio_GetDividends(_response);
        });
    }
    processPortfolio_GetDividends(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    portfolio_DownloadPortfolioExcel(applyZeroFilter, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/portfolio/getExcelFile?";
        if (applyZeroFilter !== undefined && applyZeroFilter !== null)
            url_ += "applyZeroFilter=" + encodeURIComponent("" + applyZeroFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPortfolio_DownloadPortfolioExcel(_response);
        });
    }
    processPortfolio_DownloadPortfolioExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    recovery_RecoverAuthenticationId(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/recovery";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRecovery_RecoverAuthenticationId(_response);
        });
    }
    processRecovery_RecoverAuthenticationId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    recovery_RecoverAuthenticationIdB2C(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/recovery/b2c";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRecovery_RecoverAuthenticationIdB2C(_response);
        });
    }
    processRecovery_RecoverAuthenticationIdB2C(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    sales_GetPending(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/sales";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSales_GetPending(_response);
        });
    }
    processSales_GetPending(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    sales_Cancel(accountNumber, saleId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/sales/{accountNumber}/{saleId}";
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSales_Cancel(_response);
        });
    }
    processSales_Cancel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    shareBalanceSummary_GetAccounts(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/share-balance-summary";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processShareBalanceSummary_GetAccounts(_response);
        });
    }
    processShareBalanceSummary_GetAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    shareBalanceSummary_Download(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/share-balance-summary/download";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processShareBalanceSummary_Download(_response);
        });
    }
    processShareBalanceSummary_Download(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    totp_ActionTotpGenerate(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/authentication/totp/generate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTotp_ActionTotpGenerate(_response);
        });
    }
    processTotp_ActionTotpGenerate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    totp_ActionTotpVerify(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/authentication/totp/verify";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTotp_ActionTotpVerify(_response);
        });
    }
    processTotp_ActionTotpVerify(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    userPreferences_GetUserPreferences(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/preferences";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserPreferences_GetUserPreferences(_response);
        });
    }
    processUserPreferences_GetUserPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    userProfile_ActionHandleProfileUpdate(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/profile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserProfile_ActionHandleProfileUpdate(_response);
        });
    }
    processUserProfile_ActionHandleProfileUpdate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    userRecovery_ActionRecoverySuccessEvent(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/recovery/success";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserRecovery_ActionRecoverySuccessEvent(_response);
        });
    }
    processUserRecovery_ActionRecoverySuccessEvent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    userResetProfile_CreateToken(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/recovery/reset-profile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserResetProfile_CreateToken(_response);
        });
    }
    processUserResetProfile_CreateToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    userResetProfile_GetToken(token, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/recovery/reset-profile/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserResetProfile_GetToken(_response);
        });
    }
    processUserResetProfile_GetToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    userResetProfile_GetTokenExists(token, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/recovery/reset-profile/{token}/exists";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserResetProfile_GetTokenExists(_response);
        });
    }
    processUserResetProfile_GetTokenExists(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    userResetProfile_ActionVerifySSN(token, request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/recovery/reset-profile/{token}/verify-ssn";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserResetProfile_ActionVerifySSN(_response);
        });
    }
    processUserResetProfile_ActionVerifySSN(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    users_GetDetails(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/details";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_GetDetails(_response);
        });
    }
    processUsers_GetDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    users_ActionValidateSsn(ssn, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/IsUserSocialSecurityNumber?";
        if (ssn !== undefined && ssn !== null)
            url_ += "ssn=" + encodeURIComponent("" + ssn) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_ActionValidateSsn(_response);
        });
    }
    processUsers_ActionValidateSsn(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationCache_Get(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/cache/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationCache_Get(_response);
        });
    }
    processRegistrationCache_Get(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationCache_UpdateTimestamp(id, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/cache/{id}/timestamp";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationCache_UpdateTimestamp(_response);
        });
    }
    processRegistrationCache_UpdateTimestamp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registration_ActionCheckUsernameExists(dto, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/username-exists";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(dto);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistration_ActionCheckUsernameExists(_response);
        });
    }
    processRegistration_ActionCheckUsernameExists(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registration_ActionRegistrationHandlerStep(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistration_ActionRegistrationHandlerStep(_response);
        });
    }
    processRegistration_ActionRegistrationHandlerStep(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationDspp_ActionCreateInvestment(userId, request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/dspp/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationDspp_ActionCreateInvestment(_response);
        });
    }
    processRegistrationDspp_ActionCreateInvestment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationDspp_GetRegistrationTypes(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/dspp/registrationTypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationDspp_GetRegistrationTypes(_response);
        });
    }
    processRegistrationDspp_GetRegistrationTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationDspp_ActionValidateTaxId(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/dspp/validateTaxId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationDspp_ActionValidateTaxId(_response);
        });
    }
    processRegistrationDspp_ActionValidateTaxId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationDspp_GetIssueFees(issueNumber, regionCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/dspp/issue/{issueNumber}/fees/{regionCode}";
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        if (regionCode === undefined || regionCode === null)
            throw new Error("The parameter 'regionCode' must be defined.");
        url_ = url_.replace("{regionCode}", encodeURIComponent("" + regionCode));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationDspp_GetIssueFees(_response);
        });
    }
    processRegistrationDspp_GetIssueFees(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationDspp_GetIssueFeesUsingUserRegionCode(issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/dspp/issue/{issueNumber}/fees";
        if (issueNumber === undefined || issueNumber === null)
            throw new Error("The parameter 'issueNumber' must be defined.");
        url_ = url_.replace("{issueNumber}", encodeURIComponent("" + issueNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationDspp_GetIssueFeesUsingUserRegionCode(_response);
        });
    }
    processRegistrationDspp_GetIssueFeesUsingUserRegionCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationDspp_ValidateBankField(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/dspp/validateBankField";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationDspp_ValidateBankField(_response);
        });
    }
    processRegistrationDspp_ValidateBankField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationDsppValidation_Create(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/dspp/validation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationDsppValidation_Create(_response);
        });
    }
    processRegistrationDsppValidation_Create(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    registrationOnline_ActionCreateUser(userId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/online/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationOnline_ActionCreateUser(_response);
        });
    }
    processRegistrationOnline_ActionCreateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 409) {
            const _responseText = response.data;
            let result409 = null;
            let resultData409 = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    registrationOnlineValidation_ValidateCompanyNameAndAccountNumber(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/online/validation/companyNameAndAccountNumber";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationOnlineValidation_ValidateCompanyNameAndAccountNumber(_response);
        });
    }
    processRegistrationOnlineValidation_ValidateCompanyNameAndAccountNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    registrationOnlineValidation_ValidateUserBySocialSecurityNumber(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/online/validation/socialSecurityNumber";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationOnlineValidation_ValidateUserBySocialSecurityNumber(_response);
        });
    }
    processRegistrationOnlineValidation_ValidateUserBySocialSecurityNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    registrationOnlineValidation_ValidateUserByEmployeeNumber(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/online/validation/employeeNumber";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationOnlineValidation_ValidateUserByEmployeeNumber(_response);
        });
    }
    processRegistrationOnlineValidation_ValidateUserByEmployeeNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    registrationOnlineValidation_ValidateUserByAuthenticationId(request, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/registration/online/validation/authenticationId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRegistrationOnlineValidation_ValidateUserByAuthenticationId(_response);
        });
    }
    processRegistrationOnlineValidation_ValidateUserByAuthenticationId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
    addressFormat_GetFormat(userId, countryCode, accountNumber, registrationCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/address/format?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (accountNumber === null)
            throw new Error("The parameter 'accountNumber' cannot be null.");
        else if (accountNumber !== undefined)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        if (registrationCode !== undefined && registrationCode !== null)
            url_ += "registrationCode=" + encodeURIComponent("" + registrationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAddressFormat_GetFormat(_response);
        });
    }
    processAddressFormat_GetFormat(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    addressFormat_GetFormatForCountry(countryCode, registrationCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/address/format?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (registrationCode !== undefined && registrationCode !== null)
            url_ += "registrationCode=" + encodeURIComponent("" + registrationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAddressFormat_GetFormatForCountry(_response);
        });
    }
    processAddressFormat_GetFormatForCountry(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    primaryAddress_GetPreview(userId, accountId, model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/address/preview";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPrimaryAddress_GetPreview(_response);
        });
    }
    processPrimaryAddress_GetPreview(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    primaryAddress_Confirm(userId, accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/address/confirm";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPrimaryAddress_Confirm(_response);
        });
    }
    processPrimaryAddress_Confirm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    primaryAddress_Update(userId, accountId, model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/address";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPrimaryAddress_Update(_response);
        });
    }
    processPrimaryAddress_Update(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    primaryAddress_IsPrimaryAddressBatchPending(userId, accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/address/is-primary-addres-batch-pendning";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPrimaryAddress_IsPrimaryAddressBatchPending(_response);
        });
    }
    processPrimaryAddress_IsPrimaryAddressBatchPending(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    seasonalAddress_GetPreview(userId, accountId, model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/seasonal-adresss/preview";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSeasonalAddress_GetPreview(_response);
        });
    }
    processSeasonalAddress_GetPreview(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    seasonalAddress_Create(userId, accountId, model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/seasonal-adresss";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSeasonalAddress_Create(_response);
        });
    }
    processSeasonalAddress_Create(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    seasonalAddress_Update(userId, accountId, model, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/seasonal-adresss";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSeasonalAddress_Update(_response);
        });
    }
    processSeasonalAddress_Update(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    seasonalAddress_Delete(userId, accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/seasonal-adresss";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSeasonalAddress_Delete(_response);
        });
    }
    processSeasonalAddress_Delete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    seasonalAddress_IsSeasonalAddressBatchPending(userId, accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/seasonal-adresss/is-seasonal-addres-batch-pendning";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSeasonalAddress_IsSeasonalAddressBatchPending(_response);
        });
    }
    processSeasonalAddress_IsSeasonalAddressBatchPending(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    secondaryAddress_GetPreview(userId, accountId, issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/secondary-adresss/preview?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSecondaryAddress_GetPreview(_response);
        });
    }
    processSecondaryAddress_GetPreview(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 500) {
            const _responseText = response.data;
            let result500 = null;
            let resultData500 = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    secondaryAddress_Create(userId, accountId, issueNumber, address, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/secondary-adresss?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(address);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSecondaryAddress_Create(_response);
        });
    }
    processSecondaryAddress_Create(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    secondaryAddress_Delete(userId, accountId, issueNumber, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/accounts/{accountId}/secondary-adresss?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (issueNumber !== undefined && issueNumber !== null)
            url_ += "issueNumber=" + encodeURIComponent("" + issueNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSecondaryAddress_Delete(_response);
        });
    }
    processSecondaryAddress_Delete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = JSON.parse(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
        }
    }
}
exports.SPCoreClient = SPCoreClient;
var AgreementType;
(function (AgreementType) {
    AgreementType["ESign"] = "ESign";
    AgreementType["OnlineAccess"] = "OnlineAccess";
})(AgreementType = exports.AgreementType || (exports.AgreementType = {}));
var AlertType;
(function (AlertType) {
    AlertType["None"] = "None";
    AlertType["UndeliverableAddress"] = "UndeliverableAddress";
    AlertType["OutstandingChecks"] = "OutstandingChecks";
    AlertType["TaxCertified"] = "TaxCertified";
    AlertType["AccountReCertification"] = "AccountReCertification";
    AlertType["FirstBNotice"] = "FirstBNotice";
    AlertType["SecondBNotice"] = "SecondBNotice";
    AlertType["CNotice"] = "CNotice";
})(AlertType = exports.AlertType || (exports.AlertType = {}));
var AuditLogType;
(function (AuditLogType) {
    AuditLogType["UserAuthenticated"] = "UserAuthenticated";
    AuditLogType["InvalidUsernameOrPassword"] = "InvalidUsernameOrPassword";
    AuditLogType["InvalidSecurityAnswer"] = "InvalidSecurityAnswer";
    AuditLogType["InvalidSecurityCode"] = "InvalidSecurityCode";
    AuditLogType["ChangedSecurityQuestionAndAnswer"] = "ChangedSecurityQuestionAndAnswer";
    AuditLogType["ResetPassword"] = "ResetPassword";
    AuditLogType["ChangedMfaMethod"] = "ChangedMfaMethod";
    AuditLogType["ValidateUserBySosialSecurityNumber"] = "ValidateUserBySosialSecurityNumber";
})(AuditLogType = exports.AuditLogType || (exports.AuditLogType = {}));
var RecoveryVerificationType;
(function (RecoveryVerificationType) {
    RecoveryVerificationType["AuthenticationId"] = "AuthenticationId";
    RecoveryVerificationType["AccountNumber"] = "AccountNumber";
    RecoveryVerificationType["EmployeeNumber"] = "EmployeeNumber";
    RecoveryVerificationType["SSN"] = "SSN";
})(RecoveryVerificationType = exports.RecoveryVerificationType || (exports.RecoveryVerificationType = {}));
var AccountType;
(function (AccountType) {
    AccountType["Savings"] = "Savings";
    AccountType["Checking"] = "Checking";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var MfaStatus;
(function (MfaStatus) {
    MfaStatus["NonMfa"] = "NonMfa";
    MfaStatus["AuthenticatedByPrimaryEmail"] = "AuthenticatedByPrimaryEmail";
    MfaStatus["AuthenticatedBySecondaryEmail"] = "AuthenticatedBySecondaryEmail";
    MfaStatus["AuthenticatedByPrimaryPhone"] = "AuthenticatedByPrimaryPhone";
    MfaStatus["AuthenticatedBySecondaryPhone"] = "AuthenticatedBySecondaryPhone";
    MfaStatus["AuthenticatedByAuthenticatorApp"] = "AuthenticatedByAuthenticatorApp";
})(MfaStatus = exports.MfaStatus || (exports.MfaStatus = {}));
var SolApiResponseCode;
(function (SolApiResponseCode) {
    SolApiResponseCode["Success"] = "Success";
    SolApiResponseCode["InquiryMode"] = "InquiryMode";
    SolApiResponseCode["BadRequest"] = "BadRequest";
    SolApiResponseCode["Unauthorized"] = "Unauthorized";
    SolApiResponseCode["GeneralError"] = "GeneralError";
    SolApiResponseCode["AuthenticateInvalidUserNamePassword"] = "AuthenticateInvalidUserNamePassword";
    SolApiResponseCode["AuthenticateIPAddressBlocked"] = "AuthenticateIPAddressBlocked";
    SolApiResponseCode["AuthenticateExistingPreviousPassword"] = "AuthenticateExistingPreviousPassword";
    SolApiResponseCode["AuthenticateAccountLocked"] = "AuthenticateAccountLocked";
    SolApiResponseCode["BatchedAutomaticInvestment"] = "BatchedAutomaticInvestment";
    SolApiResponseCode["BatchedDrip"] = "BatchedDrip";
    SolApiResponseCode["BuySharesPendingTransaction"] = "BuySharesPendingTransaction";
    SolApiResponseCode["UniqueTaxIdRequired"] = "UniqueTaxIdRequired";
    SolApiResponseCode["FraudValidationFailed"] = "FraudValidationFailed";
})(SolApiResponseCode = exports.SolApiResponseCode || (exports.SolApiResponseCode = {}));
var EDeliveryType;
(function (EDeliveryType) {
    EDeliveryType["None"] = "None";
    EDeliveryType["Mail"] = "Mail";
    EDeliveryType["Edelivery"] = "Edelivery";
    EDeliveryType["Both"] = "Both";
})(EDeliveryType = exports.EDeliveryType || (exports.EDeliveryType = {}));
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["ALIVE"] = "ALIVE";
    AvailabilityStatus["PARTIAL"] = "PARTIAL";
    AvailabilityStatus["MAINTENANCE"] = "MAINTENANCE";
    AvailabilityStatus["DOWN"] = "DOWN";
})(AvailabilityStatus = exports.AvailabilityStatus || (exports.AvailabilityStatus = {}));
var OperationId;
(function (OperationId) {
    OperationId["CancelPayment"] = "cancelPayment";
    OperationId["CancelRecurringPayment"] = "cancelRecurringPayment";
    OperationId["CancelTransfer"] = "cancelTransfer";
    OperationId["CreatePayee"] = "createPayee";
    OperationId["CreateTaxForm"] = "createTaxForm";
    OperationId["DeletePayee"] = "deletePayee";
    OperationId["GetAccount"] = "getAccount";
    OperationId["GetAccountContact"] = "getAccountContact";
    OperationId["GetAccountPaymentNetworks"] = "getAccountPaymentNetworks";
    OperationId["GetAccountStatement"] = "getAccountStatement";
    OperationId["GetAccountTransactionImages"] = "getAccountTransactionImages";
    OperationId["GetAvailability"] = "getAvailability";
    OperationId["GetCapability"] = "getCapability";
    OperationId["GetCertificationMetrics"] = "getCertificationMetrics";
    OperationId["GetConsentGrant"] = "getConsentGrant";
    OperationId["GetCustomer"] = "getCustomer";
    OperationId["GetCustomerInfo"] = "getCustomerInfo";
    OperationId["GetCustomers"] = "getCustomers";
    OperationId["GetPayee"] = "getPayee";
    OperationId["GetPayment"] = "getPayment";
    OperationId["GetPaymentsForRecurringPayment"] = "getPaymentsForRecurringPayment";
    OperationId["GetRecurringPayment"] = "getRecurringPayment";
    OperationId["GetRewardProgram"] = "getRewardProgram";
    OperationId["GetRewardProgramCategories"] = "getRewardProgramCategories";
    OperationId["GetTaxForm"] = "getTaxForm";
    OperationId["GetTransfer"] = "getTransfer";
    OperationId["GetTransferStatus"] = "getTransferStatus";
    OperationId["GeportSuspectedFraudIncident"] = "reportSuspectedFraudIncident";
    OperationId["GequestAccountTransfer"] = "requestAccountTransfer";
    OperationId["SchedulePayment"] = "schedulePayment";
    OperationId["ScheduleRecurringPayment"] = "scheduleRecurringPayment";
    OperationId["SearchForAccounts"] = "searchForAccounts";
    OperationId["SearchForAccountStatements"] = "searchForAccountStatements";
    OperationId["SearchForAccountTransactions"] = "searchForAccountTransactions";
    OperationId["SearchForPayees"] = "searchForPayees";
    OperationId["SearchForPayments"] = "searchForPayments";
    OperationId["SearchForRecurringPayments"] = "searchForRecurringPayments";
    OperationId["SearchForTaxForms"] = "searchForTaxForms";
    OperationId["SearchForTransfers"] = "searchForTransfers";
    OperationId["SearchRewardPrograms"] = "searchRewardPrograms";
    OperationId["UpdatePayee"] = "updatePayee";
    OperationId["UpdatePayment"] = "updatePayment";
    OperationId["UpdateRecurringPayment"] = "updateRecurringPayment";
    OperationId["UpdateTaxForm"] = "updateTaxForm";
})(OperationId = exports.OperationId || (exports.OperationId = {}));
var HoldingType;
(function (HoldingType) {
    HoldingType["ANNUITY"] = "ANNUITY";
    HoldingType["BOND"] = "BOND";
    HoldingType["CD"] = "CD";
    HoldingType["MUTUALFUND"] = "MUTUALFUND";
    HoldingType["OPTION"] = "OPTION";
    HoldingType["OTHER"] = "OTHER";
    HoldingType["STOCK"] = "STOCK";
})(HoldingType = exports.HoldingType || (exports.HoldingType = {}));
var PositionType;
(function (PositionType) {
    PositionType["LONG"] = "LONG";
    PositionType["SHORT"] = "SHORT";
})(PositionType = exports.PositionType || (exports.PositionType = {}));
var MutualFundType;
(function (MutualFundType) {
    MutualFundType["OPENEND"] = "OPENEND";
    MutualFundType["CLOSEEND"] = "CLOSEEND";
    MutualFundType["OTHER"] = "OTHER";
})(MutualFundType = exports.MutualFundType || (exports.MutualFundType = {}));
var OptionType;
(function (OptionType) {
    OptionType["CALL"] = "CALL";
    OptionType["PUT"] = "PUT";
})(OptionType = exports.OptionType || (exports.OptionType = {}));
var DebtType;
(function (DebtType) {
    DebtType["COUPON"] = "COUPON";
    DebtType["ZERO"] = "ZERO";
})(DebtType = exports.DebtType || (exports.DebtType = {}));
var AssetClass;
(function (AssetClass) {
    AssetClass["DOMESTICBOND"] = "DOMESTICBOND";
    AssetClass["INTLBOND"] = "INTLBOND";
    AssetClass["INTLSTOCK"] = "INTLSTOCK";
    AssetClass["LARGESTOCK"] = "LARGESTOCK";
    AssetClass["MONEYMARKET"] = "MONEYMARKET";
    AssetClass["OTHER"] = "OTHER";
    AssetClass["SMALLSTOCK"] = "SMALLSTOCK";
})(AssetClass = exports.AssetClass || (exports.AssetClass = {}));
var InvestmentTransactionType;
(function (InvestmentTransactionType) {
    InvestmentTransactionType["ADJUSTMENT"] = "ADJUSTMENT";
    InvestmentTransactionType["ATM"] = "ATM";
    InvestmentTransactionType["CASH"] = "CASH";
    InvestmentTransactionType["CHECK"] = "CHECK";
    InvestmentTransactionType["CLOSURE"] = "CLOSURE";
    InvestmentTransactionType["CLOSUREOPT"] = "CLOSUREOPT";
    InvestmentTransactionType["CONTRIBUTION"] = "CONTRIBUTION";
    InvestmentTransactionType["DEP"] = "DEP";
    InvestmentTransactionType["DEPOSIT"] = "DEPOSIT";
    InvestmentTransactionType["DIRECTDEBIT"] = "DIRECTDEBIT";
    InvestmentTransactionType["DIRECTDEP"] = "DIRECTDEP";
    InvestmentTransactionType["DIV"] = "DIV";
    InvestmentTransactionType["DIVIDEND"] = "DIVIDEND";
    InvestmentTransactionType["DIVIDENDREINVEST"] = "DIVIDENDREINVEST";
    InvestmentTransactionType["EXPENSE"] = "EXPENSE";
    InvestmentTransactionType["FEE"] = "FEE";
    InvestmentTransactionType["INCOME"] = "INCOME";
    InvestmentTransactionType["INTEREST"] = "INTEREST";
    InvestmentTransactionType["INVEXPENSE"] = "INVEXPENSE";
    InvestmentTransactionType["JRNLFUND"] = "JRNLFUND";
    InvestmentTransactionType["JRNLSEC"] = "JRNLSEC";
    InvestmentTransactionType["MARGININTEREST"] = "MARGININTEREST";
    InvestmentTransactionType["OPTIONEXERCISE"] = "OPTIONEXERCISE";
    InvestmentTransactionType["OPTIONEXPIRATION"] = "OPTIONEXPIRATION";
    InvestmentTransactionType["OTHER"] = "OTHER";
    InvestmentTransactionType["PAYMENT"] = "PAYMENT";
    InvestmentTransactionType["POS"] = "POS";
    InvestmentTransactionType["PURCHASED"] = "PURCHASED";
    InvestmentTransactionType["PURCHASEDTOCOVER"] = "PURCHASEDTOCOVER";
    InvestmentTransactionType["PURCHASETOCLOSE"] = "PURCHASETOCLOSE";
    InvestmentTransactionType["PURCHASETOOPEN"] = "PURCHASETOOPEN";
    InvestmentTransactionType["REINVESTOFINCOME"] = "REINVESTOFINCOME";
    InvestmentTransactionType["REPEATPMT"] = "REPEATPMT";
    InvestmentTransactionType["RETURNOFCAPITAL"] = "RETURNOFCAPITAL";
    InvestmentTransactionType["SOLD"] = "SOLD";
    InvestmentTransactionType["SOLDTOCLOSE"] = "SOLDTOCLOSE";
    InvestmentTransactionType["SOLDTOOPEN"] = "SOLDTOOPEN";
    InvestmentTransactionType["SPLIT"] = "SPLIT";
    InvestmentTransactionType["SRVCHG"] = "SRVCHG";
    InvestmentTransactionType["TRANSFER"] = "TRANSFER";
    InvestmentTransactionType["XFER"] = "XFER";
})(InvestmentTransactionType = exports.InvestmentTransactionType || (exports.InvestmentTransactionType = {}));
var DebitCreditMemo;
(function (DebitCreditMemo) {
    DebitCreditMemo["CREDIT"] = "CREDIT";
    DebitCreditMemo["DEBIT"] = "DEBIT";
    DebitCreditMemo["MEMO"] = "MEMO";
})(DebitCreditMemo = exports.DebitCreditMemo || (exports.DebitCreditMemo = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["AUTHORIZATION"] = "AUTHORIZATION";
    TransactionStatus["MEMO"] = "MEMO";
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["POSTED"] = "POSTED";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
var Iso4217Code;
(function (Iso4217Code) {
    Iso4217Code["AED"] = "AED";
    Iso4217Code["AFN"] = "AFN";
    Iso4217Code["ALL"] = "ALL";
    Iso4217Code["AMD"] = "AMD";
    Iso4217Code["ANG"] = "ANG";
    Iso4217Code["AOA"] = "AOA";
    Iso4217Code["ARS"] = "ARS";
    Iso4217Code["AUD"] = "AUD";
    Iso4217Code["AWG"] = "AWG";
    Iso4217Code["AZN"] = "AZN";
    Iso4217Code["BAM"] = "BAM";
    Iso4217Code["BBD"] = "BBD";
    Iso4217Code["BDT"] = "BDT";
    Iso4217Code["BGN"] = "BGN";
    Iso4217Code["BHD"] = "BHD";
    Iso4217Code["BIF"] = "BIF";
    Iso4217Code["BMD"] = "BMD";
    Iso4217Code["BND"] = "BND";
    Iso4217Code["BOB"] = "BOB";
    Iso4217Code["BOV"] = "BOV";
    Iso4217Code["BRL"] = "BRL";
    Iso4217Code["BSD"] = "BSD";
    Iso4217Code["BTN"] = "BTN";
    Iso4217Code["BWP"] = "BWP";
    Iso4217Code["BYR"] = "BYR";
    Iso4217Code["BZD"] = "BZD";
    Iso4217Code["CAD"] = "CAD";
    Iso4217Code["CDF"] = "CDF";
    Iso4217Code["CHE"] = "CHE";
    Iso4217Code["CHF"] = "CHF";
    Iso4217Code["CHW"] = "CHW";
    Iso4217Code["CLF"] = "CLF";
    Iso4217Code["CLP"] = "CLP";
    Iso4217Code["CNY"] = "CNY";
    Iso4217Code["COP"] = "COP";
    Iso4217Code["COU"] = "COU";
    Iso4217Code["CRC"] = "CRC";
    Iso4217Code["CUC"] = "CUC";
    Iso4217Code["CUP"] = "CUP";
    Iso4217Code["CVE"] = "CVE";
    Iso4217Code["CZK"] = "CZK";
    Iso4217Code["DJF"] = "DJF";
    Iso4217Code["DKK"] = "DKK";
    Iso4217Code["DOP"] = "DOP";
    Iso4217Code["DZD"] = "DZD";
    Iso4217Code["EGP"] = "EGP";
    Iso4217Code["ERN"] = "ERN";
    Iso4217Code["ETB"] = "ETB";
    Iso4217Code["EUR"] = "EUR";
    Iso4217Code["FJD"] = "FJD";
    Iso4217Code["FKP"] = "FKP";
    Iso4217Code["GBP"] = "GBP";
    Iso4217Code["GEL"] = "GEL";
    Iso4217Code["GHS"] = "GHS";
    Iso4217Code["GIP"] = "GIP";
    Iso4217Code["GMD"] = "GMD";
    Iso4217Code["GNF"] = "GNF";
    Iso4217Code["GTQ"] = "GTQ";
    Iso4217Code["GYD"] = "GYD";
    Iso4217Code["HKD"] = "HKD";
    Iso4217Code["HNL"] = "HNL";
    Iso4217Code["HRK"] = "HRK";
    Iso4217Code["HTG"] = "HTG";
    Iso4217Code["HUF"] = "HUF";
    Iso4217Code["IDR"] = "IDR";
    Iso4217Code["ILS"] = "ILS";
    Iso4217Code["INR"] = "INR";
    Iso4217Code["IQD"] = "IQD";
    Iso4217Code["IRR"] = "IRR";
    Iso4217Code["ISK"] = "ISK";
    Iso4217Code["JMD"] = "JMD";
    Iso4217Code["JOD"] = "JOD";
    Iso4217Code["JPY"] = "JPY";
    Iso4217Code["KES"] = "KES";
    Iso4217Code["KGS"] = "KGS";
    Iso4217Code["KHR"] = "KHR";
    Iso4217Code["KMF"] = "KMF";
    Iso4217Code["KPW"] = "KPW";
    Iso4217Code["KRW"] = "KRW";
    Iso4217Code["KWD"] = "KWD";
    Iso4217Code["KYD"] = "KYD";
    Iso4217Code["KZT"] = "KZT";
    Iso4217Code["LAK"] = "LAK";
    Iso4217Code["LBP"] = "LBP";
    Iso4217Code["LKR"] = "LKR";
    Iso4217Code["LRD"] = "LRD";
    Iso4217Code["LSL"] = "LSL";
    Iso4217Code["LYD"] = "LYD";
    Iso4217Code["MAD"] = "MAD";
    Iso4217Code["MDL"] = "MDL";
    Iso4217Code["MGA"] = "MGA";
    Iso4217Code["MKD"] = "MKD";
    Iso4217Code["MMK"] = "MMK";
    Iso4217Code["MNT"] = "MNT";
    Iso4217Code["MOP"] = "MOP";
    Iso4217Code["MRO"] = "MRO";
    Iso4217Code["MUR"] = "MUR";
    Iso4217Code["MVR"] = "MVR";
    Iso4217Code["MWK"] = "MWK";
    Iso4217Code["MXN"] = "MXN";
    Iso4217Code["MXV"] = "MXV";
    Iso4217Code["MYR"] = "MYR";
    Iso4217Code["MZN"] = "MZN";
    Iso4217Code["NAD"] = "NAD";
    Iso4217Code["NGN"] = "NGN";
    Iso4217Code["NIO"] = "NIO";
    Iso4217Code["NOK"] = "NOK";
    Iso4217Code["NPR"] = "NPR";
    Iso4217Code["NZD"] = "NZD";
    Iso4217Code["OMR"] = "OMR";
    Iso4217Code["PAB"] = "PAB";
    Iso4217Code["PEN"] = "PEN";
    Iso4217Code["PGK"] = "PGK";
    Iso4217Code["PHP"] = "PHP";
    Iso4217Code["PKR"] = "PKR";
    Iso4217Code["PLN"] = "PLN";
    Iso4217Code["PYG"] = "PYG";
    Iso4217Code["QAR"] = "QAR";
    Iso4217Code["RON"] = "RON";
    Iso4217Code["RSD"] = "RSD";
    Iso4217Code["RUB"] = "RUB";
    Iso4217Code["RWF"] = "RWF";
    Iso4217Code["SAR"] = "SAR";
    Iso4217Code["SBD"] = "SBD";
    Iso4217Code["SCR"] = "SCR";
    Iso4217Code["SDG"] = "SDG";
    Iso4217Code["SEK"] = "SEK";
    Iso4217Code["SGD"] = "SGD";
    Iso4217Code["SHP"] = "SHP";
    Iso4217Code["SLL"] = "SLL";
    Iso4217Code["SOS"] = "SOS";
    Iso4217Code["SRD"] = "SRD";
    Iso4217Code["SSP"] = "SSP";
    Iso4217Code["STD"] = "STD";
    Iso4217Code["SVC"] = "SVC";
    Iso4217Code["SYP"] = "SYP";
    Iso4217Code["SZL"] = "SZL";
    Iso4217Code["THB"] = "THB";
    Iso4217Code["TJS"] = "TJS";
    Iso4217Code["TMT"] = "TMT";
    Iso4217Code["TND"] = "TND";
    Iso4217Code["TOP"] = "TOP";
    Iso4217Code["TRY"] = "TRY";
    Iso4217Code["TTD"] = "TTD";
    Iso4217Code["TWD"] = "TWD";
    Iso4217Code["TZS"] = "TZS";
    Iso4217Code["UAH"] = "UAH";
    Iso4217Code["UGX"] = "UGX";
    Iso4217Code["USD"] = "USD";
    Iso4217Code["USN"] = "USN";
    Iso4217Code["UYI"] = "UYI";
    Iso4217Code["UYU"] = "UYU";
    Iso4217Code["UZS"] = "UZS";
    Iso4217Code["VEF"] = "VEF";
    Iso4217Code["VND"] = "VND";
    Iso4217Code["VUV"] = "VUV";
    Iso4217Code["WST"] = "WST";
    Iso4217Code["XAF"] = "XAF";
    Iso4217Code["XAG"] = "XAG";
    Iso4217Code["XAU"] = "XAU";
    Iso4217Code["XBA"] = "XBA";
    Iso4217Code["XBB"] = "XBB";
    Iso4217Code["XBC"] = "XBC";
    Iso4217Code["XBD"] = "XBD";
    Iso4217Code["XCD"] = "XCD";
    Iso4217Code["XDR"] = "XDR";
    Iso4217Code["XOF"] = "XOF";
    Iso4217Code["XPD"] = "XPD";
    Iso4217Code["XPF"] = "XPF";
    Iso4217Code["XPT"] = "XPT";
    Iso4217Code["XSU"] = "XSU";
    Iso4217Code["XTS"] = "XTS";
    Iso4217Code["XUA"] = "XUA";
    Iso4217Code["XXX"] = "XXX";
    Iso4217Code["YER"] = "YER";
    Iso4217Code["ZAR"] = "ZAR";
    Iso4217Code["ZMW"] = "ZMW";
    Iso4217Code["ZWL"] = "ZWL";
})(Iso4217Code = exports.Iso4217Code || (exports.Iso4217Code = {}));
var AccountType2;
(function (AccountType2) {
    AccountType2["_401A"] = "401A";
    AccountType2["_401K"] = "401K";
    AccountType2["_403B"] = "403B";
    AccountType2["_529"] = "529";
    AccountType2["ANNUITY"] = "ANNUITY";
    AccountType2["AUTOLOAN"] = "AUTOLOAN";
    AccountType2["BROKERAGEPRODUCT"] = "BROKERAGEPRODUCT";
    AccountType2["CD"] = "CD";
    AccountType2["CHARGE"] = "CHARGE";
    AccountType2["CHECKING"] = "CHECKING";
    AccountType2["COMMERCIALDEPOSIT"] = "COMMERCIALDEPOSIT";
    AccountType2["COMMERCIALINVESTMENT"] = "COMMERCIALINVESTMENT";
    AccountType2["COMMERCIALLINEOFCREDIT"] = "COMMERCIALLINEOFCREDIT";
    AccountType2["COMMERCIALLOAN"] = "COMMERCIALLOAN";
    AccountType2["COVERDELL"] = "COVERDELL";
    AccountType2["CREDITCARD"] = "CREDITCARD";
    AccountType2["DEFINEDBENEFIT"] = "DEFINEDBENEFIT";
    AccountType2["ESCROW"] = "ESCROW";
    AccountType2["ESOP"] = "ESOP";
    AccountType2["FIXEDANNUITY"] = "FIXEDANNUITY";
    AccountType2["GUARDIAN"] = "GUARDIAN";
    AccountType2["HOMEEQUITYLOAN"] = "HOMEEQUITYLOAN";
    AccountType2["HOMELINEOFCREDIT"] = "HOMELINEOFCREDIT";
    AccountType2["INSTALLMENT"] = "INSTALLMENT";
    AccountType2["INSTITUTIONALTRUST"] = "INSTITUTIONALTRUST";
    AccountType2["IRA"] = "IRA";
    AccountType2["KEOGH"] = "KEOGH";
    AccountType2["LINEOFCREDIT"] = "LINEOFCREDIT";
    AccountType2["LOAN"] = "LOAN";
    AccountType2["LONGTERMDISABILITY"] = "LONGTERMDISABILITY";
    AccountType2["MILITARYLOAN"] = "MILITARYLOAN";
    AccountType2["MONEYMARKET"] = "MONEYMARKET";
    AccountType2["MORTGAGE"] = "MORTGAGE";
    AccountType2["NONQUALIFIEDPLAN"] = "NONQUALIFIEDPLAN";
    AccountType2["OTHERDEPOSIT"] = "OTHERDEPOSIT";
    AccountType2["OTHERINVESTMENT"] = "OTHERINVESTMENT";
    AccountType2["PERSONALLOAN"] = "PERSONALLOAN";
    AccountType2["ROLLOVER"] = "ROLLOVER";
    AccountType2["ROTH"] = "ROTH";
    AccountType2["SARSEP"] = "SARSEP";
    AccountType2["SAVINGS"] = "SAVINGS";
    AccountType2["SMBLOAN"] = "SMBLOAN";
    AccountType2["SHORTTERMDISABILITY"] = "SHORTTERMDISABILITY";
    AccountType2["STUDENTLOAN"] = "STUDENTLOAN";
    AccountType2["TAXABLE"] = "TAXABLE";
    AccountType2["TDA"] = "TDA";
    AccountType2["TERM"] = "TERM";
    AccountType2["TRUST"] = "TRUST";
    AccountType2["UGMA"] = "UGMA";
    AccountType2["UNIVERSALLIFE"] = "UNIVERSALLIFE";
    AccountType2["UTMA"] = "UTMA";
    AccountType2["VARIABLEANNUITY"] = "VARIABLEANNUITY";
    AccountType2["WHOLELIFE"] = "WHOLELIFE";
})(AccountType2 = exports.AccountType2 || (exports.AccountType2 = {}));
var HateoasLinkAction;
(function (HateoasLinkAction) {
    HateoasLinkAction["GET"] = "GET";
    HateoasLinkAction["POST"] = "POST";
    HateoasLinkAction["PATCH"] = "PATCH";
    HateoasLinkAction["DELETE"] = "DELETE";
    HateoasLinkAction["PUT"] = "PUT";
})(HateoasLinkAction = exports.HateoasLinkAction || (exports.HateoasLinkAction = {}));
var ContentTypes;
(function (ContentTypes) {
    ContentTypes["ApplicationPdf"] = "application/pdf";
    ContentTypes["ImageGif"] = "image/gif";
    ContentTypes["ImageJpeg"] = "image/jpeg";
    ContentTypes["ImageTiff"] = "image/tiff";
    ContentTypes["ImagePng"] = "image/png";
    ContentTypes["ApplicationJson"] = "application/json";
})(ContentTypes = exports.ContentTypes || (exports.ContentTypes = {}));
var ResultType;
(function (ResultType) {
    ResultType["Lightweight"] = "lightweight";
    ResultType["Details"] = "details";
})(ResultType = exports.ResultType || (exports.ResultType = {}));
var IdvStatus;
(function (IdvStatus) {
    IdvStatus["Undefined"] = "Undefined";
    IdvStatus["Passed"] = "Passed";
    IdvStatus["Failed"] = "Failed";
    IdvStatus["Review"] = "Review";
    IdvStatus["Bypass"] = "Bypass";
    IdvStatus["Expired"] = "Expired";
    IdvStatus["Unsuccessful"] = "Unsuccessful";
    IdvStatus["Invalid"] = "Invalid";
})(IdvStatus = exports.IdvStatus || (exports.IdvStatus = {}));
var IdvKeyType;
(function (IdvKeyType) {
    IdvKeyType["Ssn"] = "Ssn";
    IdvKeyType["AuthId"] = "AuthId";
})(IdvKeyType = exports.IdvKeyType || (exports.IdvKeyType = {}));
var CompletionStatus;
(function (CompletionStatus) {
    CompletionStatus["NotStarted"] = "NotStarted";
    CompletionStatus["InProgress"] = "InProgress";
    CompletionStatus["Failed"] = "Failed";
    CompletionStatus["Processed"] = "Processed";
    CompletionStatus["Completed"] = "Completed";
})(CompletionStatus = exports.CompletionStatus || (exports.CompletionStatus = {}));
var DecisionType;
(function (DecisionType) {
    DecisionType["NotExecuted"] = "NotExecuted";
    DecisionType["Passed"] = "Passed";
    DecisionType["Rejected"] = "Rejected";
    DecisionType["Warning"] = "Warning";
})(DecisionType = exports.DecisionType || (exports.DecisionType = {}));
var SosUserAuthResponseCode;
(function (SosUserAuthResponseCode) {
    SosUserAuthResponseCode["Success"] = "Success";
    SosUserAuthResponseCode["GeneralError"] = "GeneralError";
    SosUserAuthResponseCode["UserAlreadyExists"] = "UserAlreadyExists";
    SosUserAuthResponseCode["IdvUnavailable"] = "IdvUnavailable";
    SosUserAuthResponseCode["IdvInvalidRequest"] = "IdvInvalidRequest";
    SosUserAuthResponseCode["IdvToManyRequests"] = "IdvToManyRequests";
})(SosUserAuthResponseCode = exports.SosUserAuthResponseCode || (exports.SosUserAuthResponseCode = {}));
var IdvFlowType;
(function (IdvFlowType) {
    IdvFlowType["Unknown"] = "Unknown";
    IdvFlowType["Login"] = "Login";
    IdvFlowType["RegistrationOnline"] = "RegistrationOnline";
    IdvFlowType["RegistrationDspp"] = "RegistrationDspp";
})(IdvFlowType = exports.IdvFlowType || (exports.IdvFlowType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["DirectDeposit"] = "DirectDeposit";
    PaymentMethod["Check"] = "Check";
    PaymentMethod["WireTransfer"] = "WireTransfer";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var InvestmentType;
(function (InvestmentType) {
    InvestmentType["OneTime"] = "OneTime";
    InvestmentType["Recurring"] = "Recurring";
})(InvestmentType = exports.InvestmentType || (exports.InvestmentType = {}));
var PlanType;
(function (PlanType) {
    PlanType["Undefined"] = "Undefined";
    PlanType["DPP"] = "DPP";
    PlanType["DRIP"] = "DRIP";
    PlanType["DPPSales"] = "DPPSales";
    PlanType["DRIPSales"] = "DRIPSales";
    PlanType["Sales"] = "Sales";
    PlanType["DPPDRIP"] = "DPPDRIP";
    PlanType["ESPP"] = "ESPP";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
var LossReasonType;
(function (LossReasonType) {
    LossReasonType["Lost"] = "Lost";
    LossReasonType["Stolen"] = "Stolen";
})(LossReasonType = exports.LossReasonType || (exports.LossReasonType = {}));
var RegistrationTypes;
(function (RegistrationTypes) {
    RegistrationTypes["Online"] = "Online";
    RegistrationTypes["Dspp"] = "Dspp";
    RegistrationTypes["Idv"] = "Idv";
})(RegistrationTypes = exports.RegistrationTypes || (exports.RegistrationTypes = {}));
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
